<template>
  <el-dialog
      :visible.sync="dialog.visible"
      :title="dialog.title"
      @close="dialog.close"
  >
    <p>{{ dialog.message }}</p>
    <span slot="footer">
      <el-button @click="dialog.close">Close</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { useDialogStore } from '@/stores/dialogStore'
export default {
  setup() {
    const dialog = useDialogStore()
    return { dialog }
  }
}
</script>